var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { ErrorBoundary, urlToBlob } from '@web/utils';
import { useFirebase } from '@web/firebase';
import { Button } from '../../../Button';
import { toast } from '../../../Toast';
import { usePage, usePageEdit, ImageEditor } from '../../../';
import { styled } from '@web/theme';
export var HeroImageEditor = memo(function (_a) {
    var height = _a.height, onClose = _a.onClose;
    var _b = useFirebase(), instance = _b.instance, addOrUpdatePage = _b.addOrUpdatePage;
    var data = usePage().page.data;
    var onPageChange = usePageEdit().onPageChange;
    var _c = useState(''), photoURL = _c[0], setPhotoURL = _c[1];
    var _d = useState(false), hasChanges = _d[0], setHasChanges = _d[1];
    var refPhoto = useRef(null);
    useEffect(function () {
        setPhotoURL(data.photoURL);
    }, [data.photoURL]);
    var onDrop = useCallback(function (e) {
        var _a;
        var newImage = ((_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0]) || e.target.value;
        setHasChanges(true);
        setPhotoURL(newImage);
    }, []);
    var _onSubmitImageEditMode = useCallback(function () {
        if (typeof photoURL === 'object') {
            if (refPhoto.current) {
                var photoCanvas = refPhoto.current.getImageScaledToCanvas().toDataURL('image/jpeg');
                urlToBlob(photoCanvas)
                    .then(function (file) {
                    if (file) {
                        instance === null || instance === void 0 ? void 0 : instance.pageDrive.child(data.id + "/main").put(file).then(function (snapshot) {
                            snapshot.ref.getDownloadURL()
                                .then(function (photoURL) {
                                if (addOrUpdatePage)
                                    addOrUpdatePage({ _id: data.id, data: __assign(__assign({}, data), { photoURL: photoURL }) })
                                        .then(function () {
                                        toast.success('Obrázek byl nahrán', { toastId: 'saved' });
                                        onClose();
                                    });
                                onPageChange({ data: { photoURL: photoURL } });
                            })
                                .catch(function (savingError) {
                                console.error('getDownloadURL failed:', savingError);
                            });
                        }).catch(function (savingError) {
                            console.error('Upload failed:', savingError);
                        });
                    }
                });
            }
        }
        else {
            if (addOrUpdatePage)
                addOrUpdatePage({ _id: data.id, data: __assign(__assign({}, data), { photoURL: photoURL }) })
                    .then(function () {
                    toast.success('Obrázek byl uložen', { toastId: 'saved' });
                    onClose();
                });
        }
    }, [addOrUpdatePage, instance, data.id, onPageChange, refPhoto, photoURL]);
    return (React.createElement(ErrorBoundary, null,
        React.createElement(ImageEditor, { onChange: onDrop, innerRef: refPhoto, height: height, image: photoURL, withGradient: true }),
        React.createElement(Buttons, null,
            React.createElement(EditorButton, { onClick: onClose, icon: "times" }),
            hasChanges &&
                React.createElement(EditorButton, { onClick: _onSubmitImageEditMode, cta: true }, typeof photoURL === 'object' ? 'Potvrdit a nahrát' : 'Uložit'))));
});
var EditorButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmin-height: 32px;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 2;\n"], ["\n\tmin-height: 32px;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 2;\n"])));
export var Buttons = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 80px;\n\twidth: 100%;\n  display: flex;\n  flex: none;\n  \n  > button {\n  \tmargin: auto .5rem;\n  \t\n  \t&:first-child {\n  \t\tmargin-left: auto;\n  \t}\n  \t&:last-child {\n  \t\tmargin-right: auto;\n  \t}\n  }\n"], ["\n\tposition: absolute;\n\tleft: 0;\n\tbottom: 80px;\n\twidth: 100%;\n  display: flex;\n  flex: none;\n  \n  > button {\n  \tmargin: auto .5rem;\n  \t\n  \t&:first-child {\n  \t\tmargin-left: auto;\n  \t}\n  \t&:last-child {\n  \t\tmargin-right: auto;\n  \t}\n  }\n"])));
var templateObject_1, templateObject_2;
